import { cn, Tab, Tabs } from '@heroui/react'
import { useQuery } from '@tanstack/react-query'
import ActionBar from 'components/core/ActionBar'
import { PageTitle } from 'components/core/PageTitle'
import { PageWrapper } from 'components/core/PageWrapper'
import { useEffect, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { $fetch } from 'utils/fetch'
import AnalysisPresetConfigurator from '../Analysis/AnalysisPresetConfigurator'
import CitationSchemas from '../Analysis/CitationSchemas'
import PathwayHeatmap from '../ConvoPathways/HeatMap'
import RetoolDashboard from '../ConvoPathways/Hertz'
import ReportPage from '../Report/MainReportPage'
import CallAnalytics from './CallAnalytics'

export default function Analytics() {
  const [searchParams, setSearchParams] = useSearchParams()
  const tab = useMemo(() => {
    return searchParams.get('tab')
  }, [searchParams])

  const BASE_TABS = [
    {
      value: 'calls',
      label: 'Calls',
    },
    {
      value: 'pathways',
      label: 'Pathways',
    },
    {
      value: 'presets',
      label: 'Presets',
    },
    {
      value: 'citations',
      label: 'Citations',
    },
    {
      value: 'reports',
      label: 'Reports',
    },
  ]

  const { data: { data: customTabs = [] } = {} } = useQuery({
    queryKey: ['availableTabs'],
    queryFn: () => {
      return $fetch('/dashboards/list')
    },
    staleTime: Infinity,
  })

  const TABS = useMemo(() => {
    return [...BASE_TABS, ...customTabs]
  }, [customTabs])

  const handleTabChange = (value) => {
    setSearchParams({ tab: value })
  }

  useEffect(() => {
    if (!tab) {
      setSearchParams({ tab: 'calls' })
    }
  }, [tab])

  return (
    <PageWrapper padding={tab === 'citations' ? '54px 30px 0px 54px' : '70px 30px 100px 84px'} className={cn('bg-white', { 'bg-gray-50': tab === 'calls' })}>
      <ActionBar shiftRight={tab === 'citations'} top>
        <PageTitle>Analytics</PageTitle>
        <Tabs
          selectedKey={tab}
          aria-label="Tabs"
          onSelectionChange={handleTabChange}
          classNames={{
            base: 'absolute top-2 inset-x-0 w-full flex justify-center',
          }}
          variant="underlined"
        >
          {TABS?.map(doc => (
            <Tab
              id={doc.value}
              key={doc.value}
              title={doc.label}
            />
          ))}
        </Tabs>
      </ActionBar>

      {tab === 'calls' && (
        <CallAnalytics />
      )}
      {tab === 'pathways' && (
        <PathwayHeatmap />
      )}
      {tab === 'presets' && (
        <AnalysisPresetConfigurator />
      )}
      {tab === 'citations' && (
        <CitationSchemas />
      )}
      {tab === 'reports' && (
        <ReportPage />
      )}
      {tab?.startsWith('dashboard-') && (
        <RetoolDashboard appID={tab} />
      )}
    </PageWrapper>
  )
}
